<template>
  <div class="pw-no-access">
    <v-row class="ma-0 my-8 justify-center">
      <v-col cols="12" md="8" lg="6">
        <v-alert type="info" text prominent icon="mdi-lock-outline">
          {{ message }}
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getSelectableSections, isSectionAllowed } from '../utils/nav-sections.utils';
import { loadPermissions } from '../utils/permissions';

/** Shown when the admin may not open a section, or has no section at all (spec 131). */
export default {
  name: 'NoAccess',
  data() {
    return {
      hasAnySection: true
    };
  },
  computed: {
    message() {
      return this.hasAnySection
        ? 'No tienes acceso a esta sección.'
        : 'No tienes accesos asignados. Contacta a un administrador.';
    }
  },
  async created() {
    const res = await loadPermissions();
    if (res.status === 'ok') {
      this.hasAnySection = getSelectableSections(isSectionAllowed).length > 0;
    }
  }
};
</script>

<style scoped>
.pw-no-access {
  max-width: 1200px;
}
</style>
